// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 34 ? "application" : chunkId) + "-" + {"34":"6ee1659f","52":"2b5e62cc"}[chunkId] + ".css";
};